export const emailsMock = {
  maxMailboxes: 5,
  usedMailboxes: 0,
  mailBoxes: [],
  mailboxesInQueue: [],
  mailboxesInSuspension: [],
  domains: [
    'beskedboks.dk',
    'c.dk',
    'esenet.dk',
    'kabelmail.dk',
    'lite.dk',
    'mail.dk',
    'mail.tele.dk',
    'newmail.dk',
    'nypost.dk',
    'os.dk',
    'paradis.dk',
    'pc.dk',
    'post.tele.dk',
    'post10.tele.dk',
    'post9.tele.dk',
    'privat.dk',
    'surfmail.dk',
    'surfpost.dk',
    'tdcadsl.dk',
    'youmail.dk',
    'youseepost.dk',
  ],
};

export const emailsPrivateMock = {
  ...emailsMock,
  usedMailboxes: 4,
  mailBoxes: [
    {
      email: 'test-1@mail.dk',
      aliases: [],
      aliasesInConversion: [],
      relation: 'Owner',
      associatedUsernames: [],
    },
    {
      email: 'test-2@mail.dk',
      aliases: [],
      aliasesInConversion: [],
      relation: 'none',
      associatedUsernames: ['test-1@mail.dk', 'test-3@mail.dk'],
    },
    {
      email: 'test-3@mail.dk',
      aliases: ['test-3-alias-1@mail.dk', 'test-3-alias-2@mail.dk', 'test-3-alias-3@mail.dk'],
      aliasesInConversion: [],
      relation: 'Owner',
      associatedUsernames: [],
    },
    {
      email: 'test-4@mail.dk',
      aliases: [],
      aliasesInConversion: [],
      relation: 'Legacy',
      associatedUsernames: [],
    },
  ],
  mailboxesInSuspension: [{ email: 'test-5@mail.dk', graceEndDate: '2022-12-27' }],
};

export const emailsPrivateAfterConvertToMailboxMock = {
  ...emailsPrivateMock,
  mailBoxes: [
    {
      email: 'test-1@mail.dk',
      aliases: [],
      aliasesInConversion: [],
      relation: 'Owner',
      associatedUsernames: [],
    },
    {
      email: 'test-2@mail.dk',
      aliases: [],
      aliasesInConversion: [],
      relation: 'none',
      associatedUsernames: ['test-1@mail.dk', 'test-3@mail.dk'],
    },
    {
      email: 'test-3@mail.dk',
      aliases: ['test-3-alias-2@mail.dk', 'test-3-alias-3@mail.dk'],
      aliasesInConversion: ['test-3-alias-1@mail.dk'],
      relation: 'Owner',
      associatedUsernames: [],
    },
    {
      email: 'test-4@mail.dk',
      aliases: [],
      aliasesInConversion: [],
      relation: 'Legacy',
      associatedUsernames: [],
    },
  ],
};

export const emailsPrivateNoRightsAndNoUsersMock = {
  ...emailsPrivateMock,
  mailBoxes: [
    {
      email: 'test-1@mail.dk',
      aliases: [],
      aliasesInConversion: [],
      relation: 'Owner',
      associatedUsernames: [],
    },
    {
      email: 'test-2@mail.dk',
      aliases: [],
      aliasesInConversion: [],
      relation: 'none',
      associatedUsernames: [],
    },
    {
      email: 'test-3@mail.dk',
      aliases: ['test-3-alias-2@mail.dk', 'test-3-alias-3@mail.dk'],
      aliasesInConversion: ['test-3-alias-1@mail.dk'],
      relation: 'Owner',
      associatedUsernames: [],
    },
    {
      email: 'test-4@mail.dk',
      aliases: [],
      aliasesInConversion: [],
      relation: 'Legacy',
      associatedUsernames: [],
    },
  ],
};

export const emailsOCustomerMock = {
  ...emailsMock,
  usedMailboxes: 2,
  mailBoxes: [
    {
      email: 'forening-test1@mail.dk',
      aliases: [],
      aliasesInConversion: [],
      relation: 'Owner',
      associatedUsernames: [],
    },
    {
      email: 'forening-test2@mail.dk',
      aliases: [],
      aliasesInConversion: [],
      relation: 'Owner',
      associatedUsernames: [],
    },
  ],
  mailboxesInQueue: ['forening-test3@mail.dk'],
};

export const emailsAccountSummaryMock = {
  technicalStack: 'Tdc',
  customerRelationStatus: 'IsResidentialHasSubscriptions',
  accounts: [
    {
      accountNumber: 204962572,
      paysForAccount: true,
      subscriptions: [
        {
          accountNumber: 204962572,
          subscriptionId: '5ACBB59441414A98323A86397D927942,SP13_355_17',
          paysForAccount: true,
          product: { groupId: 'NETBASIS', productName: 'YouSee Mail', productCode: 'SP13_355_17' },
          phoneNumber: null,
          address: null,
          businessMarked: false,
          rootLid: 'FO103980',
          isSplitBill: false,
          technology: 'Unknown',
          devices: [],
          packageInformation: null,
          isOfflineSubscription: false,
        },
      ],
      isYouseeAccount: false,
    },
  ],
};
